import { Box, Stack, Typography } from '@mui/material';
import { formatMoney } from '../utils/reportesData';

function KpiCard({ label, value, suffix = '', color = 'text.primary', bgcolor = '#ECEFF1' }) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 140,
        p: 2,
        bgcolor,
        borderRadius: 2,
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h6" fontWeight="bold" sx={{ color }}>
        {value}
        {suffix}
      </Typography>
    </Box>
  );
}

export default function ReporteKPIs({ kpis, metricLabel }) {
  const variacionText =
    kpis.variacion == null
      ? 'N/D'
      : `${kpis.variacion >= 0 ? '+' : ''}${kpis.variacion.toFixed(1)}%`;

  const variacionColor =
    kpis.variacion == null
      ? 'text.secondary'
      : kpis.variacion >= 0
        ? '#2E7D32'
        : '#C62828';

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{ mb: 3 }}
      useFlexGap
      flexWrap="wrap"
    >
      <KpiCard
        label={`Total ${metricLabel}`}
        value={`Bs. ${formatMoney(kpis.total)}`}
        bgcolor="#E3F2FD"
        color="#1565C0"
      />
      <KpiCard
        label="Promedio"
        value={`Bs. ${formatMoney(kpis.promedio)}`}
        bgcolor="#E8F5E9"
        color="#2E7D32"
      />
      <KpiCard
        label="Máximo"
        value={`Bs. ${formatMoney(kpis.maximo)}`}
        bgcolor="#FFF3E0"
        color="#E65100"
      />
      <KpiCard
        label="Mínimo"
        value={`Bs. ${formatMoney(kpis.minimo)}`}
        bgcolor="#F3E5F5"
        color="#6A1B9A"
      />
      <KpiCard
        label="Variación"
        value={variacionText}
        bgcolor={
          kpis.variacion == null
            ? '#ECEFF1'
            : kpis.variacion >= 0
              ? '#E8F5E9'
              : '#FFEBEE'
        }
        color={variacionColor}
      />
    </Stack>
  );
}
